import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=aaca5cec&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaca5cec')) {
      api.createRecord('aaca5cec', component.options)
    } else {
      api.reload('aaca5cec', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=aaca5cec&", function () {
      api.rerender('aaca5cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cDh17uPSmwPC/JS/comp/ImgFallback.vue"
export default component.exports